import { render, staticRenderFns } from "./LoanContacts.vue?vue&type=template&id=70f7b26e"
import script from "./LoanContacts.vue?vue&type=script&lang=js"
export * from "./LoanContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports